<!-- left hand table -->
<div style="padding:0; padding-left: 8px; font-size:18pt; font-weight: bold;">
    Service: {{ _selectedServiceDef.description }}
</div>
<table style="width: 100%; height: 580px; padding: 5px;">
    <tr>
        <td style="width: 40%">
            <div style="height: 100%;width: 100%;">
                <div style="color:blue;margin-bottom: 10px;margin-left: 3px;"><label>Available
                    Qualifications: (double-click to add)</label></div>
                 <div #tb1 class="table-container mat-elevation-z1" style="height: 500px;" tabindex="-1">
			            <table mat-table [dataSource]="dataSource1" style="width:100%">
			                <ng-container matColumnDef="question" >
			                    <th mat-header-cell *matHeaderCellDef
			                        class="table-header-style-override" style="padding-left: 4px;">Questions
			                    </th>
			                    <td mat-cell style="padding-left:4px; font-size: 9pt;width: 100% !important;"
			                        *matCellDef="let element">{{element.question}}</td>
			                </ng-container>
			              
			                <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
			                <tr mat-row
			                    *matRowDef="let row; columns: displayedColumns1; let tableRowIdx = index;"
			                    [ngClass]="{'row-selected': tableRowIdx == Idx1}"
                                (dblclick)="moveRight()"
			                    (click)="onRowClicked1(row)">
			                </tr>
			            </table>
			       </div>
			  </div>
        </td>
        <!-- DIRECTION BUTTONS -->
        <td style="width: 10%; vertical-align: middle;">
            <table style="height: 100%;width: 100%;" *ngIf="isEditable">
                <tr>
                	<td style="text-align: center;">
                		<button mat-button style="vertical-align: middle;background-color:silver;font-weight:
                                bold" (click)="moveRight()"
                                [disabled]="!selectedRow1"
                                matTooltipPosition="above"
                                matTooltip="Add a selected question to this service definition">
		                    >
		                </button> <br>
		                <button mat-button
                                style="vertical-align: middle;margin-top: 20px;background-color:silver;font-weight:
                                bold"
                                (click)="moveLeft()"
                                [disabled]="!selectedRow2"
                                matTooltipPosition="below"
                                matTooltip="Remove a selected question from this service definition">
		                    <
		                </button>
                	</td>
                </tr>
            </table>
        </td>

        <!--Right hand table -->
        <td style="width: 50%">
            <div style="height: 100%;width: 100%;">
                 <div
                    style="color:blue;margin-bottom: 10px;"><label>Selected Qualifications: (drag to
                     reorder/ double-click to remove)</label></div>

                    <div #tb2 class="table-container mat-elevation-z1"
                      style="height: 500px;"
			              tabindex="-1">
			            <table mat-table [dataSource]="dataSource2" cdkDropList
						  [cdkDropListData]="dataSource2" style="cursor:default"
						  (cdkDropListDropped)="drop($event)">

                         <ng-container matColumnDef="sequence" >
                             <th mat-header-cell *matHeaderCellDef
                                    style="width:10px;text-align:center;padding-left:4px; padding-right:4px;"
                                    class="table-header-style-override">#
                             </th>
                          <td mat-cell style="width:10px;text-align: center;font-size:9pt;padding-left: 4px;
                          padding-right:4px;"
                              *matCellDef="let element">{{element.sequence}}</td>

                         </ng-container>
						<!-- Position Column -->
						  <ng-container matColumnDef="qualifyType">
						    <th mat-header-cell *matHeaderCellDef
                                class="table-header-style-override"
                                style="text-align:center;width:26px!important;"
                                matTooltipPosition="above"
                                matTooltip="Shows if the question is an agency question (custom) or from the master list">Type
                            </th>

                              <td mat-cell *matCellDef="let element" style="width:26px!important;"
                                  [ngStyle]="{'border': '1.5px solid white',
                                   'color':'white',
                                   'padding':'3px' ,
                                   'width':'16px',
                                   'font-size':'7.5pt',
                                   'text-align': 'center',
                                   'opacity':'.44',
                                  'background-color': getBackgroundColor(element.masterFlag) }">
                                  <span>{{getQuestionType(element.masterFlag)}}</span></td>
						  </ng-container>


			                <ng-container matColumnDef="question" >
			                    <th mat-header-cell *matHeaderCellDef
                                    style="width:100%"
                                    class="table-header-style-override">Questions
			                    </th>
			                    <td mat-cell style="width: 100%; !important;padding:3px;font-size: 9pt;"
			                        *matCellDef="let element">
			                        <span *ngIf="element.masterFlag===true">{{element.question}}</span>
			                        <span *ngIf="element.masterFlag!==true">{{element.question}}</span>
			                    </td>
			                </ng-container>
			                <ng-container matColumnDef="required" >
			                    <th mat-header-cell *matHeaderCellDef
                                    style="width:10px"
                                    style="text-align: center"
                                 class="table-header-style-override"
                                    matTooltipPosition="above"
                                    matTooltip="Specifies if the answer is required or optional">Req'd
			                    </th>
			                    <td mat-cell style="width: 10px; !important;text-align:center"
			                        *matCellDef="let element">
                                    <mat-checkbox [disabled]="element.masterFlag===true || !isEditable" binary="true"
                                      [(ngModel)]="element.required"></mat-checkbox>                                    
                                </td>
			                </ng-container>

                            <ng-container matColumnDef="qualifiedAutomatchValue" >
                                <th mat-header-cell *matHeaderCellDef
                                    style="width:100px;text-align: center; padding-right: 0px;"
                                    class="table-header-style-override"
                                    matTooltipPosition="above"
                                    matTooltip="Value used to make a positive match in the auto-match process">Auto
                                    match
                                </th>

                                <td mat-cell style="width: 100px; !important; text-align:center;
                                    padding-right: 0px;padding-left: 6px" *matCellDef="let element">
                                    <dw-dropdown *ngIf="element.masterFlag"
                                                 [style]="{'font-size':'8.5pt', 'padding-right':'0'}"
                                        [dataSource]="qualAutmatchValueList"
                                        [controlWidth]="'100px'"
                                        [selectedItem]="element.qualifiedAutomatchValue"
                                        (itemSelected)="element.qualifiedAutomatchValue
                                        = $event; automatchValueSelected($event)"
                                        [disabled]="!isEditable">
                                    </dw-dropdown>

                                    <span *ngIf="!element.masterFlag"> - </span>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns2; sticky: true"></tr>
			                <tr mat-row
							    *matRowDef="let row; columns: displayedColumns2; let tableRowIdx = index;"
							    [ngClass]="{'row-selected': tableRowIdx == Idx2}" 
							    cdkDrag [cdkDragData]="row"
							    [cdkDragDisabled]="!isEditable"
                                (dblclick)="moveLeft()"
							    (click)="onRowClicked2(row)">
							   
							</tr>

			            </table>
			        </div>
            </div>
        </td>
    </tr>
</table>

<!----------------------->
<!-- ERROR LINE --------->
<!----------------------->
<div class="error-line" [hidden]='!strErr.length'
     style="text-align:left">{{ strErr }}
</div>
<!----------------------->
<!-- SAVE STRIP        -->
<!----------------------->
<div class="save-close-strip" style="bottom: 55px;" *ngIf="isEditable">

    <button  class="command-button" *ngIf="this.isEditing"
            (click)="submitRecord()" matTooltip="Submit the changes"
             matTooltipPosition="above"
            mat-button>
        <mat-icon>check_circle_outline</mat-icon>
        Submit
    </button>
    <button class="command-button" *ngIf="this.isEditing"
            (click)="cancelSubmitRecord()"
            matTooltipPosition="above"
            matTooltip="Cancel edit" mat-button>
        <mat-icon>highlight_off</mat-icon>
        Reset
    </button>
</div>
